import Page from "@jumbo/shared/Page";
import MdfExpenses from "app/pages/Master/ExpenseMaster/MdfExpenses";
import AddExpenses from "app/pages/Master/ExpenseMaster/MdfExpenses/AddExpenses";
import AccessMiddleware from "app/routes/middleware/auth/AccessMiddleware";

export const mdfExpenseRoutes = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "expense_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/expense/mdf",
        element: <Page component={MdfExpenses} layout={"vertical-default"} />,
      },
      {
        path: "/master/expense/mdf/add/:invoiceId",
        element: <Page component={AddExpenses} layout={"vertical-default"} />,
      }
    ],
  },
];
